import React from 'react';
import { useAppContext } from '../context/AppContext';
import { ArrowRight, Play } from 'lucide-react';

const EngineeringPage = () => {
  const { setContactFormOpen } = useAppContext();
  
  const engineeringAreas = [
    {
      title: "operations, logistics & SCM",
      description: "We work with some of the leading names in the industry and have positions across logistics, supply chain and procurement."
    },
    {
      title: "civil & architecture", 
      description: "Our many years of association with leading organisations across India means we have positions ranging from architects to civil engineers, surveyors to project managers."
    },
    {
      title: "engineering & industrial design",
      description: "Whatever your engineering discipline, we have jobs for you across application engineering, research and development and product development."
    },
    {
      title: "oil, gas, power & energy",
      description: "We work with some of the leading names in the industry and have positions across oil, gas, power & energy."
    },
    {
      title: "manufacturing",
      description: "From entry level positions to senior roles for the qualified professional, we have roles across manufacturing sector."
    },
    {
      title: "construction & property",
      description: "Whether you're a fresher or a experienced hand, we have the right kind of job for you across construction & property projects."
    }
  ];
  
  return (
    <div className="flex flex-col">
      {/* Hero Section - Gradient background with abstract graphics */}
      <section className="relative bg-gradient-to-r from-indigo-900 via-purple-800 to-pink-700 text-white py-20 md:py-32">
        {/* Abstract green circles like in Randstad */}
        {/* <div className="absolute top-16 right-16 w-96 h-96 bg-green-400 rounded-full opacity-90"></div>
        <div className="absolute top-32 right-32 w-64 h-64 bg-green-600 rounded-full opacity-70"></div>
        <div className="absolute top-48 right-24 w-40 h-10 bg-green-400 rounded-full opacity-90"></div>
        <div className="absolute top-64 right-44 w-6 h-6 bg-blue-400 rounded-full"></div>
        <div className="absolute top-60 right-64 w-24 h-1 bg-blue-400"></div>
        <div className="absolute top-72 right-80 w-40 h-0.5 bg-gray-400 opacity-50"></div> */}
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-2xl">
            <h1 className="text-5xl md:text-6xl font-light mb-8 leading-tight">
              a partner for talent in<br />
              <span className="font-normal">engineering.</span>
            </h1>
            <p className="text-lg mb-8 leading-relaxed max-w-xl opacity-90">
              Build your team with top operational talent. With the largest pool of pre-qualified candidates, industry expertise, deep insights into operational workforce dynamics, and proven talent validation processes in our specialised talent centers, we'll help you simplify your recruiting and scale your workforce on demand - quickly and cost-effectively.
            </p>
            
            {/* <button 
              onClick={() => setContactFormOpen(true)}
              className="bg-yellow-400 text-black font-bold py-4 px-8 rounded-md hover:bg-yellow-300 transition-colors inline-flex items-center group"
            >
              GET IN TOUCH
              <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </button> */}
          </div>
        </div>
      </section>

      {/* Split Section 1 - identifying top engineering talent */}
      <section className="grid lg:grid-cols-2 min-h-screen">
        <div className="bg-white flex items-center">
          <div className="p-12 lg:p-20 max-w-xl">
            <h2 className="text-4xl md:text-5xl font-light mb-8 text-slate-900 leading-tight">
              identifying top<br />
              <span className="font-normal">engineering talent.</span>
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              Talent is the cornerstone of success in the fast-paced world of engineering. As engineering specialists, we help business like yours daily - connecting you with innovative, reliable, efficient engineers that can help you oversee the entire project life cycle from start to finish.
            </p>
          </div>
        </div>
        <div className="bg-cover bg-center" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&h=800&fit=crop')"
        }}>
          {/* Woman with laptop in cafe setting */}
        </div>
      </section>

      {/* Split Section 2 - building a brand */}
      <section className="grid lg:grid-cols-2 min-h-screen">
        <div className="bg-cover bg-center order-2 lg:order-1" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=800&fit=crop')"
        }}>
          {/* Office meeting room setting */}
        </div>
        <div className="bg-gradient-to-br from-slate-900 via-gray-800 to-slate-700 text-white flex items-center order-1 lg:order-2">
          <div className="p-12 lg:p-20 max-w-xl">
            <h2 className="text-4xl md:text-5xl font-light mb-8 leading-tight">
              building a brand.
            </h2>
            <p className="text-lg leading-relaxed opacity-90">
              Talented engineers are in high demand, and companies have to work harder than ever before to attract the best candidates. By enhancing your employer brand and fostering diversity and inclusion, we help you attract top talent and create a workplace where every voice is valued. Our performance management programs recognize and reward excellence, driving employee engagement and retention.
            </p>
          </div>
        </div>
      </section>

      {/* Split Section 3 - experience in engineering */}
      <section className="grid lg:grid-cols-2 min-h-screen">
        <div className="bg-gray-100 flex items-center">
          <div className="p-12 lg:p-20 max-w-xl">
            <h2 className="text-4xl md:text-5xl font-light mb-8 text-slate-900 leading-tight">
              experience in<br />
              <span className="font-normal">engineering.</span>
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              EXCESSD serves a diverse range of technology-focused industries, helping organizations build and manage skilled teams with ease. Our commitment to talent enablement keeps your workforce ahead of the curve, with tailored solutions that bridge the gap between your business goals and operational execution.
            </p>
          </div>
        </div>
        <div className="bg-cover bg-center" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=1200&h=800&fit=crop')"
        }}>
          {/* Young engineer with glasses in tech environment */}
        </div>
      </section>

      {/* Workforce Insights Split Section - IMPROVED */}
      <section className="grid lg:grid-cols-2">
        <div className="relative min-h-[500px] lg:min-h-[600px] bg-cover bg-center" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=800&fit=crop')"
        }}>
          {/* Overlay for better contrast */}
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>
          {/* Circular graphics overlay */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="relative">
              <div className="w-48 h-48 border-8 border-green-400 rounded-full opacity-80" style={{
                strokeDasharray: "180 60",
                transform: "rotate(-90deg)"
              }}></div>
              <div className="absolute top-4 left-4 w-40 h-40 border-8 border-blue-400 rounded-full opacity-70" style={{
                strokeDasharray: "120 100",
                transform: "rotate(45deg)"
              }}></div>
              <div className="absolute top-8 left-8 w-32 h-32 border-8 border-white rounded-full opacity-90"></div>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-slate-900 via-gray-800 to-slate-700 text-white flex items-center min-h-[500px] lg:min-h-[600px]">
          <div className="p-12 lg:p-20 max-w-xl">
            <h2 className="text-3xl md:text-4xl font-light mb-6 leading-tight">
              workforce insights<br />
              delivered to your<br />
              inbox.
            </h2>
            <p className="text-base leading-relaxed opacity-90 mb-8">
              Want to reduce your turnover rate, improve your company culture, or be inspired on improving employability for young people? Sign up to the monthly workforce insights newsletter and stay up to date with the latest recruitment and labor market news, tips, trends and reports for business leaders across the globe.
            </p>
            {/* <button className="bg-blue-600 text-white font-medium py-3 px-8 rounded hover:bg-blue-700 transition-colors">
              subscribe
            </button> */}
          </div>
        </div>
      </section>

      {/* Video Section - engineer your next growth curve - IMPROVED */}
      {/* <section className="relative min-h-[600px] bg-cover bg-center" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=600&fit=crop&crop=center')"
      }}>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 flex items-center justify-center min-h-[600px]">
          <div className="container mx-auto px-4">
            <div className="max-w-2xl text-white text-center lg:text-left">
              <div className="mb-8">
                <div className="inline-block bg-white text-blue-600 px-6 py-3 rounded-lg text-lg font-medium mb-4">
                  engineer your next
                </div>
                <br />
                <div className="bg-blue-600 text-white px-6 py-4 rounded-lg text-2xl font-medium inline-block">
                  growth curve.
                </div>
              </div>
              <p className="text-lg mb-12 leading-relaxed opacity-90 max-w-xl">
                Our workforce solution experts offer you complete range of HR services to help achieve your current and future engineering staffing goals.
              </p>
              <button className="inline-flex items-center text-white font-medium hover:text-blue-200 transition-colors group">
                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mr-6 group-hover:bg-opacity-30 transition-all">
                  <Play size={24} className="ml-1" />
                </div>
                <span className="text-lg">watch our video to learn more</span>
              </button>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="relative bg-gradient-to-r from-indigo-900 via-purple-800 to-pink-700 text-white py-20 md:py-32">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Partner with Us?</h2>
          <p className="text-xl mb-8 opacity-90 max-w-2xl mx-auto">
            Let's discuss how we can help you leverage India's exceptional engineering talent to accelerate your business growth.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => setContactFormOpen(true)}
              className="bg-yellow-400 text-black font-bold py-4 px-8 rounded-md hover:bg-yellow-300 transition-colors inline-flex items-center justify-center group"
            >
              START CONVERSATION
              {/* <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" /> */}
            </button>
            {/* <button className="border-2 border-white text-white font-bold py-4 px-8 rounded-md hover:bg-white hover:text-blue-900 transition-colors">
              View Case Studies
            </button> */}
          </div>
        </div>
      </section>

      
    </div>
  );
};

export default EngineeringPage;